(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[821],{

/***/ 71292:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ capitalCase; }
});

// UNUSED EXPORTS: capitalCaseTransform

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/no-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(1902);
;// CONCATENATED MODULE: ./node_modules/upper-case-first/dist.es2015/index.js
/**
 * Upper case the first character of an input string.
 */
function upperCaseFirst(input) {
    return input.charAt(0).toUpperCase() + input.substr(1);
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/capital-case/dist.es2015/index.js



function capitalCaseTransform(input) {
    return upperCaseFirst(input.toLowerCase());
}
function capitalCase(input, options) {
    if (options === void 0) { options = {}; }
    return (0,dist_es2015/* noCase */.B)(input, (0,tslib_es6.__assign)({ delimiter: " ", transform: capitalCaseTransform }, options));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 18704:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cities",
      function () {
        return __webpack_require__(14682);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ CarBrandGrid; }
/* harmony export */ });
/* unused harmony export CarBrand */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var capital_case__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71292);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61275);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _util_util__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6069);
/* harmony import */ var param_case__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34539);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3210);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73401);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_8__);











var CarBrandGrid = function(param) {
    var carContent = param.carContent, title = param.title, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_4___default()("text-center", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "title mb-2",
                    children: title
                }),
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid md:grid-cols-4 sm:grid-cols-2 gap-4",
                    children: (0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .pipe */ .zGw)((0,ramda__WEBPACK_IMPORTED_MODULE_3__/* .take */ .qnb)(8), (0,_util_util__WEBPACK_IMPORTED_MODULE_5__/* .mapIndexed */ .XD)(function(post, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CarBrand, {
                            logo: post.makeLogo,
                            url: "/cars/".concat((0,param_case__WEBPACK_IMPORTED_MODULE_9__/* .paramCase */ .o)(post.makeShortName), "-brake-repair/"),
                            makeLongName: post.makeLongName
                        }, index);
                    }))(carContent)
                })
            ]
        })
    });
};
var CarBrand = function(param) {
    var logo = param.logo, makeLongName = param.makeLongName, url = param.url;
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_7__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "pb-5",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            as: {
                pathname: url,
                query: query
            },
            href: "/cars/[slug]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "shadow-lg mx-auto p-1 border-2 border-gray-100 rounded",
                        style: {
                            width: 200,
                            height: 200
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_8___default()), {
                            src: logo,
                            width: 200,
                            height: 200,
                            alt: "".concat(capital_case__WEBPACK_IMPORTED_MODULE_10__/* .capitalCase */ .I(makeLongName), " Logo")
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pt-4 font-normal text-lg",
                        children: "".concat(capital_case__WEBPACK_IMPORTED_MODULE_10__/* .capitalCase */ .I(makeLongName), " Brake Repair")
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 68663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H4": function() { return /* binding */ YelpButton; },
/* harmony export */   "Ig": function() { return /* binding */ ButtonOutline; },
/* harmony export */   "Op": function() { return /* binding */ ViewAllCitiesButton; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony export LearnMoreButton */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var Button = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "disabled:bg-green-300 disabled:cursor-not-allowed";
    var baseClassName = "inline-block justify-center bg-lime hover:bg-green-600 text-white py-2 text-lg font-semibold px-5 rounded";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, disabledClassName, className)
    }, rest), {
        children: children
    }));
};
var LearnMoreButton = function(param) {
    var children = param.children;
    var baseClassName = "ml-1 inline-block justify-center bg-blue-900 text-white text-sm px-2 rounded";
    return /*#__PURE__*/ _jsx("button", {
        className: classNames(baseClassName),
        children: children
    });
};
var ButtonOutline = function(_param) {
    var children = _param.children, className = _param.className, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "disabled"
    ]);
    var disabledClassName = "opacity-50 cursor-not-allowed";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        disabled: disabled,
        className: "".concat(className, " border-primary hover:text-white border inline-block justify-center bg-transparent hover:bg-primary text-primary py-2 text-lg font-semibold px-5 rounded ").concat(disabled ? disabledClassName : "")
    }, rest), {
        children: children
    }));
};
var YelpButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block w-full md:w-auto  border-gray-800 border justify-center bg-transparent hover:bg-gray-800 hover:text-white text-gray-800 py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};
var ViewAllCitiesButton = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "inline-block border-allCitiesGray border justify-center bg-transparent hover:bg-allCitiesGray hover:text-white text-allCitiesGray py-2 text-lg font-semibold px-5 rounded",
        children: children
    });
};


/***/ }),

/***/ 96729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CitiesCTA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68663);
/* harmony import */ var _hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73401);
/* harmony import */ var _utils_string_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2638);







var CitiesCTA = function(param) {
    var _phoneNumber = param.phoneNumber, phoneNumber = _phoneNumber === void 0 ? "8558005629" : _phoneNumber, className = param.className;
    var query = (0,_hooks_useQueryParam__WEBPACK_IMPORTED_MODULE_5__/* .useQueryParam */ .W)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex flex-col items-center", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-center w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                    href: {
                        pathname: "/get-quote/",
                        query: query
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .zx, {
                            className: "w-full block sm:w-auto sm:inline py-2 px-6",
                            children: "GET A QUOTE"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mt-3",
                children: [
                    "Or call us at ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "tel:".concat(phoneNumber),
                        children: (0,_utils_string_utils__WEBPACK_IMPORTED_MODULE_6__/* .formatPhoneNumber */ .u)(phoneNumber)
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 87762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ FastAndReliableSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3210);



var FastAndReliableSection = function(param) {
    var title = param.title;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center pt-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "title",
                    children: title || "FAST AND RELIABLE BRAKE REPAIR"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                    className: "description text-xl",
                    children: [
                        "Experience fast and reliable brake repair you can trust, confidently backed by over",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: "15,000 five-star Google Reviews"
                        }),
                        " from satisfied customers. At Nubrakes, we understand that your brakes are your car's most important safety feature. That's why we take care of them like they're our own. Our skilled technicians use only high-quality parts and equipment to ensure you get the best brake repair possible."
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 14399:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FAQ; },
/* harmony export */   "v": function() { return /* binding */ FAQSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcVisa__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(73977);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcAmex__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63543);
/* harmony import */ var _fortawesome_free_brands_svg_icons_faCcDiscover__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83708);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3210);
/* harmony import */ var react_animate_height__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68133);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93024);













var FAQSection = function(param) {
    var title = param.title, description = param.description;
    /*React.useEffect(() => {
    if (iFrameResize)
      iFrameResize({ checkOrigin: false, heightCalculationMethod: 'taggedElement' }, '#SP_cmFDSnceVq2r7aASVGuT')
  }, [iFrameResize])*/ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "jsx-d85d3d4a3bb65347" + " " + "text-center bg-gray-50",
        children: [
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "d85d3d4a3bb65347",
                children: ".title.jsx-d85d3d4a3bb65347{font-size:40px;color:#000;font-weight:700}.description.jsx-d85d3d4a3bb65347{font-size:18px;color:#7c7c7c;font-weight:400}@media(max-width:768px){.title.jsx-d85d3d4a3bb65347{font-size:24px;color:#000;font-weight:700}}"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-d85d3d4a3bb65347",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "jsx-d85d3d4a3bb65347" + " " + "title max-w-xs mx-auto lg:max-w-full",
                                children: title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-d85d3d4a3bb65347" + " " + "description",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-d85d3d4a3bb65347" + " " + "grid grid-cols-1 md:grid-cols-2 gap-6",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "What does your quote include?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "At NuBrakes, transparency is at the core of our process. Your quote includes everything: parts, labor, and taxes."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "After providing a preliminary quote, your technician will perform a thorough in-person inspection to confirm the recommended repairs, ensuring no surprises."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "How does the diagnosis work?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "We’ll provide a preliminary diagnosis over the phone or via text to guide the next steps. During your appointment, your technician will perform a thorough inspection and determine the final recommended repairs."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "They’ll walk you through their findings, explain everything clearly, and provide a detailed inspection report. You’ll receive the report before making any decisions, ensuring full transparency and control."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "Once you’ve reviewed the findings, discussed your options, and authorized the work, we’ll get started right away. With NuBrakes, you’re always in the driver’s seat, and we aim to have you back on the road in no time."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "Who handles the repairs?",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "jsx-d85d3d4a3bb65347",
                                    children: "Your vehicle will be serviced by NuBrakes-certified technicians with years of hands-on experience in brake repair. Each technician is a trusted member of our team, ensuring your vehicle is in expert hands."
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "What type of parts do you use?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "We typically match the brake pad type to your vehicle’s Original Equipment Manufacturer (OEM) specifications, whether ceramic or semi-metallic. We always use Platinum-grade parts or better to ensure optimal braking performance and reliability."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "If you have specific preferences or questions about the parts used, we’re happy to discuss bespoke options tailored to your needs. At NuBrakes, your safety and satisfaction are our top priorities."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "Do you offer a warranty",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "jsx-d85d3d4a3bb65347",
                                    children: [
                                        "Absolutely! All repairs are backed by our ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                            href: "/warranty",
                                            children: "NuBrakes Guarantee"
                                        }),
                                        ", which includes a warranty of up to 2 years / 24,000 miles. You can drive with confidence knowing your brakes are built to last."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FAQ, {
                                question: "Do you do any other auto repairs?",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "While our primary focus is providing expert brake repairs and brake service, we also offer other essential maintenance items, such as oil changes and battery replacements. Unlike traditional repair shops, we don’t push unnecessary upsells—just honest, straightforward care to keep your vehicle running smoothly."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-d85d3d4a3bb65347",
                                        children: "If you have other service needs, speak to your service advisor—they’ll be happy to help explore how we can assist you."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FAQ, {
                                question: "How do I pay for my repairs?",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "jsx-d85d3d4a3bb65347" + " " + "px-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "jsx-d85d3d4a3bb65347" + " " + "answer",
                                            children: "We make payment easy and convenient—no credit card is required to schedule your appointment. Once your service is complete, you can pay on-site using any major credit or debit card. We also offer flexible financing options to make it even easier to get the repairs you need. We do not accept cash as a payment method."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "jsx-d85d3d4a3bb65347",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcVisa__WEBPACK_IMPORTED_MODULE_7__/* .faCcVisa */ .k9,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_8__/* .faCcMastercard */ .N$R,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcAmex__WEBPACK_IMPORTED_MODULE_9__/* .faCcAmex */ .ve,
                                                    className: "mx-1",
                                                    size: "2x"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                                    icon: _fortawesome_free_brands_svg_icons_faCcDiscover__WEBPACK_IMPORTED_MODULE_10__/* .faCcDiscover */ .fp,
                                                    className: "mx-1",
                                                    size: "2x"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FAQ = function(param) {
    var question = param.question, children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var height = isOpen ? "auto" : 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col flex-grow",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "text-left rounded-md overflow-hidden border border-gray-200",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-4 py-3 h-100 bg-white",
                        style: {
                            cursor: "pointer"
                        },
                        onClick: function() {
                            return setIsOpen(!isOpen);
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex pr-4",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_3__/* .FontAwesomeIcon */ .G, {
                                        icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_11__/* .faPlus */ .r8p,
                                        className: "mx-1",
                                        size: "1x"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "question mb-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                        className: "capitalize",
                                        children: question
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_animate_height__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        duration: 350,
                        height: height,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "py-4 bg-white",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "answer px-3",
                                    children: children
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 18737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ GraySection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);






var GraySection = function(_param) {
    var className = _param.className, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className",
        "children"
    ]);
    var baseClassName = "bg-gray-100";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(baseClassName, className)
    }, props), {
        children: children
    }));
};


/***/ }),

/***/ 28763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ HappinessGuaranteeSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68481);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3210);





var HappinessGuaranteeSection = function(param) {
    var description = param.description, title = param.title, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "#fff3f0" : _backgroundColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "text-center",
        style: {
            backgroundColor: backgroundColor
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                    icon: _fortawesome_pro_duotone_svg_icons_faShieldCheck__WEBPACK_IMPORTED_MODULE_4__/* .faShieldCheck */ .ip,
                    color: "#f04f23",
                    size: "7x"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "py-4 title",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description",
                    children: description
                })
            ]
        })
    });
};


/***/ }),

/***/ 97102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ServicesSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61275);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Navbar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97134);
/* harmony import */ var _Container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3210);







var servicesArray = Object.values(_Navbar__WEBPACK_IMPORTED_MODULE_4__/* .services */ .uZ);
var brakeRepairServices = [];
var generalMaintenanceServices = [];
var otherServices = [];
servicesArray.forEach(function(service) {
    if (service.groupName === "Brake Services") {
        brakeRepairServices.push(service);
    } else if (service.groupName === "General Maintenance" || service.groupName === "Lights") {
        generalMaintenanceServices.push(service);
    } else {
        otherServices.push(service);
    }
});
var otherServicesGroups = Object.entries(ramda__WEBPACK_IMPORTED_MODULE_2__/* .groupBy */ .vMG(function(service) {
    return service.groupName;
}, otherServices));
var ServicesSection = function(param) {
    var cityName = param.cityName, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()("pt-0 pb-0", className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Container__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W, {
            className: "text-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    children: [
                        cityName ? "".concat(cityName, " ") : "",
                        "BRAKE REPAIR SERVICES"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description mb-4 pb-0",
                    children: "We offer Top Notch Brake Repair Services, choose one that you want to be delivered right on your door steps."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "list-none m-0 p-0 flex flex-wrap",
                    children: brakeRepairServices.map(function(service) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "w-full ml-0 mb-2 sm:w-1/2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: service.link,
                                children: service.linkTitle
                            })
                        }, service.link);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                    className: "mt-8",
                    children: [
                        cityName ? "".concat(cityName, " ") : "",
                        "GENERAL MAINTENANCE"
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "description mb-4 pb-0",
                    children: "Nubrakes: Your Trusted Brake Specialists, Committed to Comprehensive Auto Care Solutions for Unmatched Performance and Customer Satisfaction."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: "list-none m-0 p-0 flex flex-wrap ",
                    children: generalMaintenanceServices.map(function(service) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "w-full ml-0 mb-2 sm:w-1/2",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: service.link,
                                className: "text-lg",
                                children: service.linkTitle
                            })
                        }, service.link);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-wrap justify-center mt-4",
                    children: otherServicesGroups.map(function(param) {
                        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(param, 2), groupName = _param[0], groupServices = _param[1];
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full sm:w-1/2 p-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    children: groupName
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: "list-none m-0 p-0",
                                    children: groupServices.map(function(service) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-4",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: service.link,
                                                children: service.linkTitle
                                            })
                                        }, service.link);
                                    })
                                })
                            ]
                        }, groupName);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 90832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p_": function() { return /* reexport */ SegmentLogOnMount; },
  "XX": function() { return /* reexport */ Segment; }
});

// UNUSED EXPORTS: LogOnChange, SegmentProvider, useSegment

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/lib/segment/SegmentProvider.tsx



var SegmentContext = /*#__PURE__*/ react.createContext({
    eventProperties: {}
});
function useSegmentContext() {
    return react.useContext(SegmentContext);
}
function SegmentProvider(props) {
    var writeKey = props.writeKey;
    // Memoize so it's only really called if the params change
    var segmentClient = React.useMemo(function() {
        return AnalyticsBrowser.load({
            writeKey: writeKey
        });
    }, [
        writeKey
    ]);
    // We need to init such that LogOnMount is happy
    return /*#__PURE__*/ _jsx(SegmentContext.Provider, {
        value: {
            segmentClient: segmentClient,
            eventProperties: {}
        },
        children: props.children
    });
}

;// CONCATENATED MODULE: ./src/lib/segment/Segment.tsx
/* eslint-disable @typescript-eslint/no-unused-vars */ // import { DateTime } from 'luxon'



function Segment_useSegment() {
    var eventProperties = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = useSegmentContext(), segmentClient = ref.segmentClient, inheritedProperties = ref.eventProperties;
    return react.useMemo(function() {
        var logEvent = function logEvent(eventType) {
            var eventPropertiesIn = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, callback = arguments.length > 2 ? arguments[2] : void 0;
            if (!segmentClient) {
                return;
            }
        // let computed = inheritedProperties
        // if (typeof eventProperties === 'function') {
        //   computed = eventProperties(computed)
        // } else {
        //   computed = { ...computed, ...(eventProperties || {}) }
        // }
        // if (typeof eventPropertiesIn === 'function') {
        //   computed = eventPropertiesIn(computed)
        // } else {
        //   computed = { ...computed, ...(eventPropertiesIn || {}) }
        // }
        // // event_time
        // computed = { ...computed, event_time: DateTime.now().toSeconds() }
        // segmentClient.track(eventType, computed, callback)
        };
        var instrument = // eslint-disable-next-line @typescript-eslint/ban-types
        function instrument(eventType, func) {
            function fn() {
                for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                    params[_key] = arguments[_key];
                }
                var retVal = func ? func.apply(void 0, (0,_to_consumable_array/* default */.Z)(params)) : undefined;
                logEvent(eventType);
                return retVal;
            }
            return fn;
        };
        return {
            logEvent: logEvent,
            instrument: instrument,
            eventProperties: inheritedProperties,
            segmentClient: segmentClient
        };
    }, [
        eventProperties,
        inheritedProperties,
        segmentClient
    ]);
}
function Segment(props) {
    var ref = Segment_useSegment(undefined), logEvent = ref.logEvent, instrument = ref.instrument, eventProperties = ref.eventProperties;
    // If we're not providing any additional properties, just get out of the way and call the component
    if (!eventProperties) {
        return typeof props.children === "function" ? props.children({
            logEvent: logEvent,
            instrument: instrument
        }) : props.children || null;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    // const value = React.useMemo(
    //   () => ({
    //     eventProperties: { ...eventProperties, ...(props.eventProperties || {}) },
    //     segmentClient,
    //   }),
    //   [eventProperties, props.eventProperties, segmentClient]
    // )
    return typeof props.children === "function" ? props.children({
        logEvent: logEvent,
        instrument: instrument
    }) : props.children || null;
// <SegmentContext.Provider value={value}>
//   {typeof props.children === 'function' ? props.children({ logEvent, instrument }) : props.children || null}
// </SegmentContext.Provider>
}

;// CONCATENATED MODULE: ./src/lib/segment/LogOnMount.tsx


var SegmentLogOnMount = function(param) {
    var eventType = param.eventType, children = param.children, eventProperties = param.eventProperties;
    var logEvent = Segment_useSegment().logEvent;
    react.useEffect(function() {
        logEvent(eventType, eventProperties);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return children || null;
};

;// CONCATENATED MODULE: ./src/lib/segment/LogOnChange.tsx


var SegmentLogOnChange = function(props) {
    var logEvent = useSegment().logEvent;
    React.useEffect(function() {
        logEvent(props.eventType, props.eventProperties);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.value
    ]);
    return props.children || null;
};

;// CONCATENATED MODULE: ./src/lib/segment/index.tsx






/***/ }),

/***/ 14682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ cities; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@builder.io/react/dist/builder-react.es5.js
var builder_react_es5 = __webpack_require__(18202);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 240 modules
var es = __webpack_require__(61275);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 1 modules
var Layout = __webpack_require__(22932);
// EXTERNAL MODULE: ./src/components/HappinessGuaranteeSection.tsx
var HappinessGuaranteeSection = __webpack_require__(28763);
// EXTERNAL MODULE: ./src/components/Builder/components/CarBrandGrid.tsx
var CarBrandGrid = __webpack_require__(65105);
// EXTERNAL MODULE: ./src/util/util.tsx
var util = __webpack_require__(6069);
// EXTERNAL MODULE: ./node_modules/react-star-rating-component/index.js
var react_star_rating_component = __webpack_require__(64396);
var react_star_rating_component_default = /*#__PURE__*/__webpack_require__.n(react_star_rating_component);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./src/components/Container.tsx
var components_Container = __webpack_require__(3210);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/GraySection.tsx
var components_GraySection = __webpack_require__(18737);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js
var index_es = __webpack_require__(67814);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
;// CONCATENATED MODULE: ./src/components/ReviewsPage/ReviewsList.tsx











var ReviewsList = function(param) {
    var reviewConnection = param.reviewConnection;
    return /*#__PURE__*/ _jsx(GraySection, {
        children: /*#__PURE__*/ _jsx(Container, {
            children: pipe(prop("edges"), mapIndexed(function(review, index) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "pb-4",
                    children: /*#__PURE__*/ _jsx(ReviewCard, {
                        review: review
                    })
                }, index);
            }))(reviewConnection)
        })
    });
};
var ReviewCard = function(param) {
    var review = param.review;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    var shouldBeExpandable = review.comment.length > 200;
    var formatDate = dayjs_min_default()(review.dateCreated).format("M/D/YYYY");
    var toggleExpansion = function() {
        return setIsExpanded(!isExpanded);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col p-5 h-100",
        style: {
            boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.1)",
            background: "white"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mb-0",
                        style: {
                            fontFamily: "IndustryInc-Base",
                            fontSize: 12
                        },
                        children: review.reviewerName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_star_rating_component_default()), {
                        name: "rating",
                        value: Number(review.rating),
                        editing: false,
                        renderStarIconHalf: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faStar */.Tab,
                                    color: "gold"
                                })
                            });
                        },
                        renderStarIcon: function(index, value) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: index <= value ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faStar */.Tab,
                                    color: "gold"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faStar */.Tab,
                                    color: "gold"
                                })
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    fontSize: 20,
                    color: "#707070"
                },
                children: shouldBeExpandable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandableText, {
                    text: review.comment,
                    isExpanded: isExpanded,
                    toggleExpansion: toggleExpansion
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: review.comment
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-auto",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row justify-end",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mr-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                                color: "#707070",
                                children: formatDate
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                            color: "#15d90e",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faCheckCircle */.f8k,
                                        color: "#14d90d"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "pl-1",
                                        style: {
                                            fontFamily: "IndustryInc-Base"
                                        },
                                        children: "Verified"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var ExpandableText = function(param) {
    var text = param.text, toggleExpansion = param.toggleExpansion, isExpanded = param.isExpanded;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    var textToDisplay = isExpanded ? text : (0,es/* pipe */.zGw)((0,es/* take */.qnb)(200), (0,es/* concat */.zoF)(es.__, "..."))(text);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                textToDisplay,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                    style: {
                        backgroundColor: "#d5d5d5"
                    },
                    onClick: toggleExpansion,
                    children: isExpanded ? "-" : "+"
                })
            ]
        })
    });
};
var Pill = function(param) {
    var color = param.color, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            borderRadius: 12,
            border: "solid .5px ".concat(color),
            color: color,
            fontSize: 12,
            paddingLeft: 8,
            paddingRight: 8,
            fontFamily: "IndustryInc-Base"
        },
        children: children
    });
};

// EXTERNAL MODULE: ./src/components/FAQSection.tsx
var FAQSection = __webpack_require__(14399);
// EXTERNAL MODULE: ./src/hooks/useQueryParam.tsx
var useQueryParam = __webpack_require__(73401);
// EXTERNAL MODULE: ./src/components/ServicesSection.tsx
var ServicesSection = __webpack_require__(97102);
// EXTERNAL MODULE: ./src/components/CityPage/FastAndReliableSection.tsx
var FastAndReliableSection = __webpack_require__(87762);
// EXTERNAL MODULE: ./src/components/CityPage/CitiesCTA.tsx
var CitiesCTA = __webpack_require__(96729);
// EXTERNAL MODULE: ./src/lib/segment/index.tsx + 4 modules
var segment = __webpack_require__(90832);
;// CONCATENATED MODULE: ./src/pages/cities/index.tsx


















builder_react_es5/* builder.init */.fl.init("ed7f20b509364fd4a7e520373ff39fd7");
var CitiesPage = function(props) {
    var carsContent = props.carsContent, reviews = props.reviews, citiesGrouped = props.citiesGrouped;
    var query = (0,useQueryParam/* useQueryParam */.W)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        title: "Cities We Operate In - NuBrakes Mobile Brake Repair",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: "description",
                    content: "NuBrakes operates in cities all across the United State. Come see if we operate in a city near you."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(segment/* Segment */.XX, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(segment/* LogOnMount */.p_, {
                        eventType: "Page Viewed"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col items-center p-6 py-10 pb-0",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "max-w-5xl",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-center justify-center ",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: "BRAKE REPAIR THAT COMES TO YOU"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "description",
                                            children: "Discover our extensive network of convenient locations, providing unparalleled mobile brake repair services and general car maintenance wherever you need them."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                            className: "p-0 pb-4",
                                            children: marketsByState.map(function(param) {
                                                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), state = _param[0], markets = _param[1];
                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-col",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                            className: "text-center mb-4",
                                                            children: state.toUpperCase()
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 mb-4 w-full",
                                                            children: markets.map(function(marketData) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "flex flex-col items-center md:items-start mb-4",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                                            className: "mb-0",
                                                                            children: [
                                                                                "NUBRAKES ",
                                                                                marketData.name.toUpperCase()
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            className: "text-2xl font-semibold",
                                                                            href: "tel:".concat(marketData.phone),
                                                                            children: marketData.phone
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                                            className: "border-0 w-full mt-2 mb-4 h-[18rem] lg:h-[22rem]",
                                                                            loading: "lazy",
                                                                            allowFullScreen: true,
                                                                            referrerPolicy: "no-referrer-when-downgrade",
                                                                            src: "https://www.google.com/maps/embed/v1/place?key=".concat("AIzaSyBWC6myML7m_2VvLL9NYl6S3NhgnsvCYDk", "\n  &q=").concat(marketData.googleMapsQuery)
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "description flex flex-col items-center md:items-start pb-0",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                    children: marketData.address
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "flex flex-row gap-4 flex-wrap justify-center md:justify-start",
                                                                                    children: marketData.workingHours.map(function(workingHours) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "flex flex-col items-center md:items-start text-center",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                    children: [
                                                                                                        workingHours.fromDay,
                                                                                                        " - ",
                                                                                                        workingHours.toDay
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                    children: [
                                                                                                        workingHours.fromHour,
                                                                                                        " - ",
                                                                                                        workingHours.toHour
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }, "".concat(marketData.name, "-").concat(workingHours.fromDay, "-").concat(workingHours.toDay));
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "flex w-full",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: {
                                                                                    pathname: "/get-quote/",
                                                                                    query: query
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    className: "w-full",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                                                                                        className: "w-full block py-2 px-6",
                                                                                        children: "GET A QUOTE"
                                                                                    })
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                }, marketData.name);
                                                            })
                                                        })
                                                    ]
                                                }, state);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ServicesSection/* ServicesSection */.$, {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CitiesCTA/* CitiesCTA */.B, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CarBrandGrid/* CarBrandGrid */.Q, {
                                    title: "We Offer Auto Repair Services On Nearly Every Model",
                                    carContent: carsContent,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-6"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FastAndReliableSection/* FastAndReliableSection */.s, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "pt-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-center",
                                            children: "MOST TRUSTED MOBILE BRAKE REPAIR SERVICE WITH 15,000+ 5 STAR REVIEWS"
                                        }),
                                        reviews === null || reviews === void 0 ? void 0 : reviews.map(function(review, index) {
                                            var isLast = index === reviews.length - 1;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-".concat(isLast ? 0 : 8),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ReviewCard, {
                                                    review: review
                                                })
                                            }, "".concat(review.reviewerName, "-").concat(review.comment));
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "pt-6",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                            className: "text-center mb-6",
                                            children: "Brake repair service FAQ"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FAQSection/* FAQ */.Z, {
                                                    question: "What does your quote include?",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "We pride ourselves on a fully transparent quote and repair process. Each quote includes parts, labor, and taxes. On average, our prices are 15-40% lower than your standard dealership or auto repair shop."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "After the quote over the phone, our mechanics will then do an official inspection with you in person for recommended repairs."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(FAQSection/* FAQ */.Z, {
                                                    question: "How does the diagnosis work?",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "We will give you a preliminary diagnosis over the phone. Using that diagnosis as a guide, a trained mechanic will then do an inspection with you in person to determine final recommended repairs."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "If the in-person diagnosis reveals that you do not need any repairs at this time, we will charge a $79 diagnostic fee that can be used as credit for a future repair."
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            children: "If you decline all recommended repairs during the in-person diagnosis, we will charge a $79 service call fee, which cannot be used as credit, to pay for the costs of the in-person visit."
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQ */.Z, {
                                                    question: "Who handles the repairs?",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "All of our technicians have extensive brake repair knowledge with years of experience and are directly employed by NuBrakes, so you know you’re in good hands."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQ */.Z, {
                                                    question: "What type of parts do you use?",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "We only use premium brake parts that are built to match the OEM (Original Manufacturer Equipment) standards to ensure you’re getting the best braking performance possible."
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQ */.Z, {
                                                    question: "Do you offer a warranty",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        children: [
                                                            "We do! All of our work is backed by our ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/warranty",
                                                                children: "NuBrakes Guarantee"
                                                            }),
                                                            " to ensure your brakes perform as they should each and every day."
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FAQSection/* FAQ */.Z, {
                                                    question: "Do you do any other auto repairs?",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        children: "Our primary focus is brake repairs and brake service. The best part is we can’t upsell you on unnecessary repairs like traditional repair shops because we don’t even offer them!"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CitiesCTA/* CitiesCTA */.B, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    className: "pt-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "list-none p-0 m-0",
                                        children: citiesGrouped.map(function(state) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: state.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        className: "list-none p-0 mt-6 mb-8 grid md:grid-cols-2 gap-4",
                                                        children: state.items.map(function(item, index) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                style: {
                                                                    paddingTop: index === 0 ? 0 : 8
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: item.path,
                                                                    as: {
                                                                        pathname: item.path,
                                                                        query: query
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: "Brake Repair Near Me In ".concat(item.name, ", ").concat(state.stateAbbreviation)
                                                                    })
                                                                })
                                                            }, item.name);
                                                        })
                                                    })
                                                ]
                                            }, state.name);
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HappinessGuaranteeSection/* HappinessGuaranteeSection */.M, {
                        title: "We have a 100% NuBrakes Happiness Guarantee!",
                        description: "We want to make the brake repair process simple and frustration-free. If you're not happy with your repair or replacement, we'll do everything we can to fix it. Call or message us any day, any time, and we'll do our best to fix whatever issue you're having."
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var cities = (CitiesPage);
var MarketEnum;
(function(MarketEnum) {
    MarketEnum[// Texas (TX)
    "Austin"] = "Austin";
    MarketEnum["Dallas"] = "Dallas";
    MarketEnum["Houston"] = "Houston";
    MarketEnum["San Antonio"] = "San Antonio";
    MarketEnum[// Georgia (GA)
    "Atlanta"] = "Atlanta";
    MarketEnum[// Tennessee (TN)
    "Nashville"] = "Nashville";
    MarketEnum["Chattanooga"] = "Chattanooga";
    MarketEnum["Knoxville"] = "Knoxville";
    MarketEnum[// Florida (FL)
    "Orlando"] = "Orlando";
    MarketEnum["Miami"] = "Miami";
    MarketEnum["Tampa"] = "Tampa";
    MarketEnum["Jacksonville"] = "Jacksonville";
    MarketEnum[// Illinois (IL)
    "Chicago"] = "Chicago";
})(MarketEnum || (MarketEnum = {}));
var marketsData = [
    // Texas (TX)
    {
        market: MarketEnum.Austin,
        name: "Austin",
        stateName: "Texas",
        stateAbbreviation: "TX",
        phone: "+1 512-640-2560",
        address: "5205 Airport Blvd UNIT 200, Austin, TX 78751, USA",
        googleMapsQuery: "nubrakes.com+Austin,Austin+TX",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Friday",
                fromHour: "7:00 AM",
                toHour: "9:00 PM"
            },
            {
                fromDay: "Saturday",
                toDay: "Sunday",
                fromHour: "7:00 AM",
                toHour: "9:00 PM"
            }, 
        ]
    },
    {
        market: MarketEnum.Dallas,
        name: "Dallas",
        stateName: "Texas",
        stateAbbreviation: "TX",
        phone: "+1 469-706-3497",
        address: "902 N Riverfront Blvd Ste B Dallas, TX 75207, USA",
        googleMapsQuery: "nubrakes.com+Dallas,Dallas+TX",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Sunday",
                fromHour: "7:00 AM",
                toHour: "9:00 PM"
            }, 
        ]
    },
    {
        market: MarketEnum.Houston,
        name: "Houston",
        stateName: "Texas",
        stateAbbreviation: "TX",
        phone: "+1 832-706-4115",
        address: "6322 Alder Dr, Houston, Texas 77081, USA",
        googleMapsQuery: "nubrakes.com+Houston,Houston+TX",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Sunday",
                fromHour: "7:00 AM",
                toHour: "7:00 PM"
            }, 
        ]
    },
    {
        market: MarketEnum["San Antonio"],
        name: "San Antonio",
        stateName: "Texas",
        stateAbbreviation: "TX",
        phone: "+1 210-794-6444",
        address: "1777 NE Interstate 410 Loop Suite 600, San Antonio, TX 78217, USA",
        googleMapsQuery: "nubrakes.com+San+Antonio,San+Antonio+TX",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Sunday",
                fromHour: "7:00 AM",
                toHour: "7:00 PM"
            }, 
        ]
    },
    // Georgia (GA)
    {
        market: MarketEnum.Atlanta,
        name: "Atlanta",
        stateName: "Georgia",
        stateAbbreviation: "GA",
        phone: "+1 470-467-7736",
        address: "730 Peachtree St NE #570, Atlanta, GA 30308, USA",
        googleMapsQuery: "nubrakes.com+Atlanta,Atlanta+GA",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Sunday",
                fromHour: "7:00 AM",
                toHour: "7:00 PM"
            }, 
        ]
    },
    // Tennessee (TN)
    {
        market: MarketEnum.Nashville,
        name: "Nashville",
        stateName: "Tennessee",
        stateAbbreviation: "TN",
        phone: "+1 629-206-1979",
        address: "40 Burton Hills Blvd #200, Nashville, TN 37215, USA",
        googleMapsQuery: "nubrakes.com+Nashville,Nashville+GA",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Sunday",
                fromHour: "7:00 AM",
                toHour: "7:00 PM"
            }, 
        ]
    },
    // Florida (FL)
    {
        market: MarketEnum.Orlando,
        name: "Orlando",
        stateName: "Florida",
        stateAbbreviation: "FL",
        phone: "+1 689-216-4829",
        address: "618 E South St STE 500, Orlando, FL 32801, USA",
        googleMapsQuery: "nubrakes.com+Orlando,Orlando+FL",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Sunday",
                fromHour: "7:30 AM",
                toHour: "7:00 PM"
            }, 
        ]
    },
    {
        market: MarketEnum.Miami,
        name: "Miami",
        stateName: "Florida",
        stateAbbreviation: "FL",
        phone: "+1 786-780-2495",
        address: "333 SE 2nd Ave Suite 2000, Miami, FL 33131, USA",
        googleMapsQuery: "nubrakes.com+Miami,Miami+FL",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Sunday",
                fromHour: "7:00 AM",
                toHour: "7:00 PM"
            }, 
        ]
    },
    {
        market: MarketEnum.Tampa,
        name: "Tampa",
        stateName: "Florida",
        stateAbbreviation: "FL",
        phone: "+1 813-957-9076",
        address: "100 Ashley Drive South, Tampa, FL 33602, USA",
        googleMapsQuery: "nubrakes.com+Tampa,Tampa+FL",
        workingHours: [
            {
                fromDay: "Monday",
                toDay: "Sunday",
                fromHour: "7:30 AM",
                toHour: "7:00 PM"
            }, 
        ]
    }
];
var marketsByState = es/* toPairs */.Zpf(es/* groupBy */.vMG(function(item) {
    return item.stateName;
}, marketsData));


/***/ }),

/***/ 1902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ noCase; }
});

;// CONCATENATED MODULE: ./node_modules/lower-case/dist.es2015/index.js
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */
var SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            İ: "\u0069",
            I: "\u0131",
            İ: "\u0069",
        },
    },
    az: {
        regexp: /\u0130/g,
        map: {
            İ: "\u0069",
            I: "\u0131",
            İ: "\u0069",
        },
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "\u0069\u0307",
            J: "\u006A\u0307",
            Į: "\u012F\u0307",
            Ì: "\u0069\u0307\u0300",
            Í: "\u0069\u0307\u0301",
            Ĩ: "\u0069\u0307\u0303",
        },
    },
};
/**
 * Localized lower case.
 */
function localeLowerCase(str, locale) {
    var lang = SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang)
        return lowerCase(str.replace(lang.regexp, function (m) { return lang.map[m]; }));
    return lowerCase(str);
}
/**
 * Lower case as a function.
 */
function lowerCase(str) {
    return str.toLowerCase();
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/no-case/dist.es2015/index.js

// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var DEFAULT_SPLIT_REGEXP = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g];
// Remove all non-word characters.
var DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
/**
 * Normalize the string into something other libraries can manipulate easier.
 */
function noCase(input, options) {
    if (options === void 0) { options = {}; }
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? lowerCase : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = replace(replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while (result.charAt(start) === "\0")
        start++;
    while (result.charAt(end - 1) === "\0")
        end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */
function replace(input, re, value) {
    if (re instanceof RegExp)
        return input.replace(re, value);
    return re.reduce(function (input, re) { return input.replace(re, value); }, input);
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 34539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ paramCase; }
});

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/no-case/dist.es2015/index.js + 1 modules
var dist_es2015 = __webpack_require__(1902);
;// CONCATENATED MODULE: ./node_modules/dot-case/dist.es2015/index.js


function dotCase(input, options) {
    if (options === void 0) { options = {}; }
    return (0,dist_es2015/* noCase */.B)(input, (0,tslib_es6.__assign)({ delimiter: "." }, options));
}
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ./node_modules/param-case/dist.es2015/index.js


function paramCase(input, options) {
    if (options === void 0) { options = {}; }
    return dotCase(input, (0,tslib_es6.__assign)({ delimiter: "-" }, options));
}
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4976,7948,2978,8202,6907,2932,9774,2888,179], function() { return __webpack_exec__(18704); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);